import { render, staticRenderFns } from "./infoTransport.vue?vue&type=template&id=74a5cc69&scoped=true&"
import script from "./infoTransport.vue?vue&type=script&lang=js&"
export * from "./infoTransport.vue?vue&type=script&lang=js&"
import style0 from "./infoTransport.vue?vue&type=style&index=0&id=74a5cc69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5cc69",
  null
  
)

export default component.exports